import deviceMenu from '@js/common/deviceMenu.js';
import { initAOS } from '@js/common/aos.js';
import { appendSVGBtn, headeraddClass } from '@js/common/customFunctions.js';

deviceMenu();
initAOS();
/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.pdh-detail-wrap h1').forEach((el) => {
        el.innerHTML = el.innerHTML.replace(/&nbsp;/g, ' ');
    });

    /* Process buttons */
    document
        .querySelectorAll('.btn-link, .btn-play')
        .forEach(function(element) {
            if (element.classList.contains('btn-link')) {
                appendSVGBtn(element, '#icon-arrow-right', '18', '18');
            } else if (element.classList.contains('btn-play')) {
                appendSVGBtn(element, '#icon-logo', '37', '30');
            }
        });
    /* Process buttons End */

    /* Show search bar on click start */
    const searchButton = document.querySelector(
        'header.main-header .header-search .header-search-btn',
    );
    const searchWrap = searchButton.parentNode.querySelector('.h-search-wrap');
    const body = document.body;

    searchButton.addEventListener('click', function() {
        this.classList.toggle('is-click');
        searchWrap.classList.toggle('is-open');
        body.classList.toggle('scroll-fixed');

        setTimeout(() => {
            const searchInput = this.parentElement.querySelector(
                'input[type="search"]',
            );
            if (searchInput) {
                searchInput.focus();
            }
        }, 100);
    });

    // Hide search bar on click
    const overlay = document.querySelector(
        'header.main-header .header-search .h-search-overlay',
    );
    const closeButton = document.querySelector(
        'header.main-header .header-search .h-search-close',
    );

    function closeSearchPanel() {
        searchButton.classList.remove('is-click');
        searchWrap.classList.remove('is-open');
        body.classList.remove('scroll-fixed');
    }

    if (overlay) {
        overlay.addEventListener('click', closeSearchPanel);
    }
    if (closeButton) {
        closeButton.addEventListener('click', closeSearchPanel);
    }
    /* Show search bar on click end */

    /************************************
	 ******** All Function Start *********
	 ************************************/
    // initResponsiveTables();
    headeraddClass();

    /* Menu link Change # to javascript:void(0) */
    document
        .querySelectorAll(
            'header.main-header ul li a[href="#"], footer.main-footer ul li a[href="#"]',
        )
        .forEach((link) => {
            link.setAttribute('href', 'javascript:void(0);');
        });
});

/* Use jQuery code Start
------------------------------------------------------------------------------*/

(function($) {
    // Write code here
    jQuery('.error404,.main-content ').css(
        '--HeaderHeight',
        $('.main-header').outerHeight() + 'px',
    );

    /* Social Icon Start*/
    document.querySelectorAll('a').forEach(function(element) {
        if (element.classList.contains('heateor_sss_button_linkedin')) {
            appendSVGBtn(element, '#icon-linkedin', '22', '22');
        } else if (element.classList.contains('heateor_sss_button_x')) {
            appendSVGBtn(element, '#icon-twitter', '20', '19');
        } else if (element.classList.contains('heateor_sss_facebook')) {
            appendSVGBtn(element, '#icon-facebook', '11', '22');
        } else if (element.classList.contains('heateor_sss_more')) {
            appendSVGBtn(element, '#icon-share', '16', '23');
        }
    });
    document
        .querySelectorAll('.post-hero-section .heateor_sss_sharing_ul > a')
        .forEach(function(el) {
            el.removeAttribute('style');
        });
    /* Social Icon End*/

    /* Table Wrapper */
    $(
        '.wysiwyg-component table , .post-detail-block .pdb-desc table , .wysiwyg-component  table',
    ).wrap('<div class=\'table-wrapper\'><span class=\'h3\'>Table</span></div>');
    /* Table Wrapper End */

    /* Image Hotspot Start */
    $('.interactive-infographic .drag_element .point_style').on(
        'click',
        function(event) {
            event.stopPropagation();
            $(this).closest('.drag_element').siblings().removeClass('active');
            $(this).closest('.drag_element').toggleClass('active');
        },
    );

    $('.interactive-infographic .drag_element').each(function() {
        $(this).append('<div class="tooltip-wrap"></div>');
    });

    $('.mwp-map-dropdown-wrap .dropdown-title').on('click', function(event) {
        event.stopPropagation();
        $(this).toggleClass('active');
        $(this).parent().find('.mwp-map-dropdown').slideToggle();

        $('.mwp-map-dropdown .mwp-dropdown-link').on('click', function(event) {
            event.stopPropagation();
            const $text = $(this).text();
            $(this)
                .parent()
                .addClass('active')
                .siblings()
                .removeClass('active');
            $(this).parents('.mwp-map-dropdown').slideUp();
            $(this)
                .parents('.mwp-map-dropdown-wrap')
                .find('.dropdown-title')
                .removeClass('active')
                .empty()
                .append($text);

            const $mapWrap = $(this).parents('.mwp-map-wrap');
            $mapWrap.find('.mwp-map-content').hide();
            $mapWrap.find('.drag_element').removeClass('active');

            const activeId = $(this).attr('data-href');
            $mapWrap
                .find('.mwp-map-content[data-id="' + activeId + '"]')
                .fadeIn();
            $mapWrap
                .find('.drag_element[id="' + activeId + '"]')
                .addClass('active');
        });
    });

    $('.interactive-infographic .drag_element').each(function() {
        var tooltipDataHtml = $(this)
            .find('.ihotspot_tooltop_html')
            .attr('data-html');
        const wrapDiv = $('<div class="wrap_drag_element"></div>');
        wrapDiv.html(tooltipDataHtml);
        const blankDiv = $(this).find('.tooltip-wrap');
        blankDiv.html(tooltipDataHtml);
        var tooltipDataHtml = $('body').find('#powerTip').attr('data-html');
    });

    $('.interactive-infographic .drag_element').each(function() {
        const id = $(this).attr('id');
        const content = $(this).find('.tooltip-wrap').clone();
        const newContent = $(
            '<div class="mwp-map-content" data-id="' + id + '"></div>',
        ).append(content);
        $('.mwp-map-content-wrap').append(newContent);
    });

    if ($(window).width() > 991) {
        const $mapPoint = $('.point_style, .drag_element');
        $(document).on('click', function(e) {
            if (
                !$mapPoint.is(e.target) &&
				$mapPoint.has(e.target).length === 0
            ) {
                $('.drag_element').removeClass('active');
            }
        });
    }
    /* Image Hotspot End */
})(jQuery);

/* ------------------------------------------------------------------------------
Use jQuery code End */

// Top banner js
document.addEventListener('DOMContentLoaded', function() {
    const banner = document.querySelector('.mh-banner');
    if (!banner) {
        return;
    }

    const closeBtn = banner.querySelector('.mh-innerbanner svg');

    // Get the root (HTML) element to set CSS variable
    const root = document.documentElement;

    // If cookie exists, hide banner and adjust variable
    const bannerClosed = document.cookie
        .split('; ')
        .find((row) => row.startsWith('banner_closed='));
    if (bannerClosed) {
        banner.style.display = 'none';
        root.style.setProperty('--BannerOffset', '0rem');
        return;
    }

    // When user clicks close
    closeBtn.addEventListener('click', () => {
        banner.style.display = 'none';
        root.style.setProperty('--BannerOffset', '0rem');

        // Set cookie for 30 days
        const expiry = new Date();
        expiry.setDate(expiry.getDate() + 30);
        document.cookie = `banner_closed=true; expires=${expiry.toUTCString()}; path=/`;
    });
});

// document.addEventListener('DOMContentLoaded', function() {
//     const parentUl = document.querySelector('.navigation > ul.menu');

//     if (!parentUl) {return;}

//     // Only top-level <li> (ignore nested sub-menu li)
//     const topItems = Array.from(parentUl.children).filter(
//         (li) => !li.classList.contains('sub-menu'),
//     );

//     // Remove top-level items
//     topItems.forEach((li) => li.remove());

//     const columns = 3;
//     const divs = [];

//     // Create 3 wrapper divs WITH CLASS
//     for (let i = 0; i < columns; i++) {
//         const div = document.createElement('div');
//         div.classList.add('footer-col');   // <<< ADD YOUR CLASS HERE
//         divs.push(div);
//         parentUl.appendChild(div);
//     }

//     // Distribute li column-wise
//     topItems.forEach((li, index) => {
//         const colIndex = index % columns;
//         divs[colIndex].appendChild(li);
//     });
// });
